
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import TroubleshootingPlayer from './TroubleshootingPlayer.vue'

declareVrunComponent('troubleshootingPlayer.vrun.component', TroubleshootingPlayer)